
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { getCookie, setCookie, removeCookie } from '../common/js/utils'
import router from '../router/index.js'
export default {
directives: {},
components: {
Msg,
Divider,
XButton
},
data() {
return {
view: {
title: '',
description: '错误啦',
icon: 'warn',
buttons: [





{
type: 'default',
text: '回到首页',
link: '/'
}
]
}
}
},
created() {
let message = this.$route.query.message
this.view.description = message
self.platform = this.$config.platform
self.partnerId = this.$config.partnerId
let path = ''
if (self.platform == 'partner') {
path = '/?partnerId=' + self.partnerId
} else if (self.platform == 'homeH5') {
path = '/'
} else if (self.platform == 'appointmentH5') {
path = '/appointment'
} else if (self.platform == 'miniprogram') {
path = '/appointment?miniprogram=1'
}
this.view.buttons[0].link = path















}
}



// WEBPACK FOOTER //
// ./src/components/Failure.vue